import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <div className=" flex justify-center items-center text-gray-800">
        <p className=" font-light font-sans text-xs ">
          Designed & developed by: {""}
          <a href="https://lorrainedeoduco.vercel.app" className="hover:text-[salmon]" target={"_blank"} rel="noreferrer">Loanne D.</a>
        </p>
      </div>
      <div className=" flex justify-center items-center text-gray-800 p-4">
        <p className=" font-light font-sans text-xs">
          Copyrights {currentYear}. © All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
